export const EmptyApplication = () => ({
  flow: "",
  "main-applicant": {
    "personal-details": {
      salutation: "",
      "first-name": "",
      "middle-name": "",
      "last-name": "",
      email: "",
      "phone-number": "",
      "alt-phone-number": "",
      "work-phone": "",
      "date-of-birth": "",
      "language-preference": "",
      "is-retired": false,
      sin: {
        1: "",
        2: "",
        3: ""
      },
      "first-time-home-buyer": null,
      own: "",
      "monthly-rent": "",
      "marital-status": "",
      "num-children": null,
      coapp: null,
      risklevel: "",
      addresses: [{
        city: "",
        line1: "",
        line2: "",
        "postal-code": "",
        province: "",
        "street-direction": "",
        "street-name": "",
        "street-number": "",
        "unit-number": "",
        "street-type": "",
        "time-at": null
      }]
    },
    identifications: [{
      type: "",
      country: "",
      number: ""
    }],
    employment: [{
      "current-job": null,
      "employer-name": "",
      "work-phone": "",
      "job-title": "",
      "company-type": "",
      "employment-type": "",
      "self-employed": null,
      "operating-as": "",
      "gross-revenue": "",
      occupation: "",
      "industry-sector": "",
      "income-type": "",
      "income-period": "",
      "income-amount": "",
      address: {
        city: "",
        line1: "",
        line2: "",
        "postal-code": "",
        province: "",
        "street-direction": "",
        "street-name": "",
        "street-number": "",
        "unit-number": "",
        "street-type": "",
        "time-at": null
      },
      "time-at-job": null,
      "months-in-industry": null
    }],
    "other-income": [{
      type: "",
      "income-period": "",
      amount: "",
      description: ""
    }],
    assets: [{
      type: "",
      amount: "",
      description: ""
    }],
    liabilities: [{
      type: "",
      limit: "",
      balance: "",
      payment: "",
      "maturity-date": "",
      payoff: "",
      description: ""
    }],
    "other-properties": [{
      "property-details": {
        address: {
          city: "",
          line1: "",
          line2: "",
          "postal-code": "",
          province: "",
          "street-direction": "",
          "street-name": "",
          "street-number": "",
          "unit-number": "",
          "street-type": "",
          "time-at": null
        },
        "estimated-value": "",
        "purchase-price": "",
        "purchase-date": ""
      },
      "property-costs": {
        "include-in-tds": null,
        "property-taxes": "",
        "maintenance-fees": "",
        "perc-of-total-maint-fees": "",
        "fees-include-heat": null,
        heating: ""
      },
      "property-rental": {
        occupancy: "",
        "monthly-income": "",
        "rental-income-options": "",
        "rental-income-options-percent": "",
        hydro: "",
        management: "",
        repairs: "",
        others: "",
        insurance: "",
        interest: ""
      },
      "other-property-existing-mortgages": [{
        "mortgage-type": "",
        "balance-remaining": "",
        "orig-amount": "",
        "payment-amount": "",
        frequency: "",
        "maturity-date": "",
        "rate-type": "",
        "term-type": "",
        lender: "",
        payoff: "",
        "loan-type": "",
        "interest-rate": ""
      }]
    }]
  },
  "co-applicants": [{
    id: "",
    "personal-details": {
      "co-applicant-type": "",
      "relationship-to-main-applicant": "",
      salutation: "",
      "first-name": "",
      "middle-name": "",
      "last-name": "",
      email: "",
      "phone-number": "",
      "alt-phone-number": "",
      "work-phone": "",
      "first-time-home-buyer": null,
      own: "",
      "is-retired": false,
      "monthly-rent": "",
      risklevel: "",
      addresses: [{
        city: "",
        line1: "",
        line2: "",
        "postal-code": "",
        province: "",
        "street-direction": "",
        "street-name": "",
        "street-number": "",
        "unit-number": "",
        "street-type": "",
        "time-at": null
      }],
      "date-of-birth": "",
      "language-preference": "",
      sin: {
        1: "",
        2: "",
        3: ""
      },
      "marital-status": ""
    },
    identifications: [{
      type: "",
      country: "",
      number: ""
    }],
    employment: [{
      "current-job": null,
      "employer-name": "",
      "work-phone": "",
      "job-title": "",
      "company-type": "",
      "employment-type": "",
      "self-employed": null,
      "operating-as": "",
      "gross-revenue": "",
      occupation: "",
      "industry-sector": "",
      "income-type": "",
      "income-period": "",
      "income-amount": "",
      address: {
        city: "",
        line1: "",
        line2: "",
        "postal-code": "",
        province: "",
        "street-direction": "",
        "street-name": "",
        "street-number": "",
        "unit-number": "",
        "street-type": "",
        "time-at": null
      },
      "time-at-job": null,
      "months-in-industry": null
    }],
    "other-income": [{
      type: "",
      "income-period": "",
      amount: "",
      description: ""
    }],
    assets: [{
      type: "",
      amount: "",
      description: ""
    }],
    liabilities: [{
      type: "",
      limit: "",
      balance: "",
      payment: "",
      "maturity-date": "",
      payoff: "",
      description: ""
    }],
    "other-properties": [{
      "property-details": {
        address: {
          city: "",
          line1: "",
          line2: "",
          "postal-code": "",
          province: "",
          "street-direction": "",
          "street-name": "",
          "street-number": "",
          "unit-number": "",
          "street-type": "",
          "time-at": null
        },
        "estimated-value": "",
        "purchase-price": "",
        "purchase-date": ""
      },
      "property-costs": {
        "include-in-tds": null,
        "property-taxes": "",
        "maintenance-fees": "",
        "perc-of-total-maint-fees": "",
        "fees-include-heat": null,
        heating: ""
      },
      "property-rental": {
        occupancy: "",
        "monthly-income": "",
        "rental-income-options": "",
        "rental-income-options-percent": "",
        hydro: "",
        management: "",
        repairs: "",
        others: "",
        insurance: "",
        interest: ""
      },
      "other-property-existing-mortgages": [{
        "mortgage-type": "",
        "balance-remaining": "",
        "orig-amount": "",
        "payment-amount": "",
        frequency: "",
        "maturity-date": "",
        "rate-type": "",
        "term-type": "",
        lender: "",
        payoff: "",
        "loan-type": "",
        "interest-rate": ""
      }]
    }]
  }],
  property: {
    details: {
      address: {
        city: "",
        line1: "",
        line2: "",
        "postal-code": "",
        province: "",
        "street-direction": "",
        "street-name": "",
        "street-number": "",
        "unit-number": "",
        "street-type": "",
        "time-at": null
      },
      "purchase-date": "",
      "living-space": "",
      occupancy: "",
      "rental-property": null,
      "monthly-income": "",
      "mls-listing": null,
      lot: "",
      block: "",
      "conc-township": "",
      "purchase-price": "",
      "estimated-value": "",
      "appraised-value": "",
      "appraisal-date": "",
      "property-value-index": ""
    },
    styles: {
      "property-style": "",
      "property-type": "",
      "garage-size": "",
      "garage-style": "",
      "construction-type": "",
      "structure-age": "",
      "number-of-units": "",
      tenure: "",
      "lot-size": "",
      "lot-size-type": "",
      heat: "",
      "water-info": "",
      "environmental-hazard": null,
      "sewage-info": ""
    },
    costs: {
      "property-taxes": "",
      "tax-year": "",
      "tax-responsible": "",
      "rental-income-options": "",
      "rental-income-options-percent": "",
      "perc-of-total-maint-fees": "",
      "maintenance-fees": "",
      "fees-include-heat": null,
      heating: "",
      hydro: "",
      insurance: "",
      management: "",
      repairs: "",
      interest: "",
      others: "",
      "include-in-tds": null
    },
    "existing-mortgages": [{
      "mortgage-type": "",
      "balance-remaining": "",
      "payment-amount": "",
      frequency: "",
      "maturity-date": "",
      "rate-type": "",
      "term-type": "",
      lender: "",
      "loan-type": "",
      payoff: "",
      "orig-amount": "",
      "interest-rate": "",
      "current-mortgage-number": "",
      "blended-amortization": null,
      insured: null,
      "insurance-account-number": "",
      "mortgage-insurance-provider-id": "",
      "refi-additional-info": ""
    }]
  },
  "mortgage-details": {
    "down-payment": [{
      amount: "",
      source: "",
      description: ""
    }],
    "mortgage-details": {
      "closing-date": "",
      "financing-waiver": "",
      purpose: "",
      improvements: null,
      "improvements-description": "",
      "improvements-value": ""
    },
    mortgages: [{
      amount: "",
      requested: "",
      insured: null
    }, {
      amount: "",
      requested: "",
      insured: null
    }, {
      amount: "",
      requested: "",
      insured: null
    }]
  },
  "submission-details": [{
    "submission-details": {
      lender: "",
      "mortgage-type": "",
      "interest-adjustment-date": "",
      "loan-type": "",
      "first-payment-date": "",
      "maturity-date": "",
      "progress-advance": null,
      "line-of-business": "",
      insured: null,
      "include-in-mortgage": null,
      "loc-repayment-type": "",
      "mortgage-insurance-provider-id": "",
      "mi-premium-override": null,
      "mi-premium-rate": "",
      "mi-premium-amount": "",
      "interest-rate": "",
      "discount-rate": "",
      "premium-rate": "",
      "buy-down-rate": "",
      "rate-type": "",
      "term-type": "",
      frequency: "",
      "compounded-period": "",
      "term-years": "",
      "term-months": "",
      "amortization-years": "",
      "amortization-months": "",
      "blended-amortization": null,
      "interest-only": null,
      "variable-to-prime": ""
    },
    "mortgage-classifications": {
      commercial: null,
      construction: null,
      reverse: null,
      subprime: null,
      heloc: null,
      "qualified-syndicated": null,
      "non-qualified-syndicated": null,
      suspicioustransaction: null,
      bridgeloan: null
    },
    "qualifying-details": {
      "interest-rate": "",
      "interest-only": null,
      "compounded-period": "",
      "amortization-years": "",
      "amortization-months": ""
    },
    notes: [{
      note: "",
      category: "",
      "entry-date": ""
    }]
  }]
});